import { makeFetchSlice, fetchEdgeDataThunk } from 'app/redux-fetch'
import { AppDispatch } from 'app/store'
import { fetchAvailableLicenses, homeApplyLicense } from 'features/home/api'
import {
  HOME_APPLY_LICENSE_REDUCER_NAME,
  HOME_AVAILABLE_LICENSES_LIST_REDUCER_NAME,
} from 'features/home/consts'

const homeAvailableLicensesListSlice = makeFetchSlice(
  HOME_AVAILABLE_LICENSES_LIST_REDUCER_NAME
)
export const homeAvailableLicensesListReducer =
  homeAvailableLicensesListSlice.reducer
export const homeAvailableLicensesListActions =
  homeAvailableLicensesListSlice.actions

export const fetchAvailableLicensesThunk = (
  homeId: string,
  domainId: string
) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: homeAvailableLicensesListActions,
        asyncFunc: () => fetchAvailableLicenses({ domainId, homeId }),
      })
    } catch (error) {
      console.log('Error fetching home Applied Licenses', error)
    }
  }
}

const homeApplyLicenseSlice = makeFetchSlice(HOME_APPLY_LICENSE_REDUCER_NAME)

export const homeApplyLicenseReducer = homeApplyLicenseSlice.reducer
export const homeApplyLicenseActions = homeApplyLicenseSlice.actions

export const homeApplyLicenseThunk = (
  domainId: string,
  homeId: string,
  licenseId: number
) => {
  return async (dispatch: AppDispatch) =>
    await fetchEdgeDataThunk({
      dispatch,
      actions: homeApplyLicenseActions,
      asyncFunc: () => homeApplyLicense({ domainId, homeId, licenseId }),
    })
}
